<template lang="pug">
    .main-page
      errors-modal(
      v-if="showWarningModal"
      @close="showWarningModal = false"
      :text="notificaton"
      )
      .main-page__title-screen
        title-screen
      .main-page__body
        .container
          section.main-page__section.section(
          v-if="campsData.length >= 2"
          )
            .section__title
              h3.section-title Лагеря
            .section__body
              camps-slider(
              :slider-data="campsData"
              )
          //section.main-page__section.section
          //  .section__title
          //    h3.section-title Смены
          //  .section__body
          //    coming-camp-shifts(
          //      :slider-data="shiftsData"
          //    )
          //    router-link.button.button_full.button_paint-main.hide-xs-up(
          //      to="/pages/camps/"
          //    )
          //      .button__text Смотреть все
      .main-page__footer
        main-footer
</template>

<script>
import {mapActions, mapState} from "vuex";

import TitleScreen from "@/views/mainPage/TitleScreen.vue";
import ComingCampShifts from "@/views/mainPage/ComingCampShifts.vue";
import MainFooter from "@/components/footer/Footer.vue";
import Rating from "@/components/rating/Rating.vue";
import CampsSlider from "../../components/camps-slider/CampsSlider";
import ErrorsModal from "@/components/modals/ErrorModal.vue";

export default {
  name: "MainPage",
  components: {
    CampsSlider,
    TitleScreen,
    Rating,
    ComingCampShifts,
    MainFooter,
    ErrorsModal
  },
  data() {
    return {
      campsData: [],
      shiftsData: [],
      showWarningModal: true,
      notificaton: "Уважаемые пользователи! <br> ОБРАТИТЕ ВНИМАНИЕ! <br> САЙТ РАБОТАЕТ В РЕЖИМЕ ОЗНАКОМЛЕНИЯ. <br> Здесь вы можете получить всю интересующую вас информацию о работе детских оздоровительных лагерей республики. По вопросам бронирования и приобретения обращаться  непосредственно в лагеря или в их центры продаж путевок. <br> Телефон горячей линии: <br> 8 (843) 207-28-73 <br> 8 (953)999-10-59"
    };
  },
  methods: {
    ...mapActions(["getCamps", "getShifts"])
  },
  mounted() {
    this.getCamps(
      {
        params: {
          limit: 8,
          random: true
        }
      }).then(res => {
      this.campsData = res.results;
    });
    this.getShifts({
      params: {
        limit: 6
      }
    }).then(res => {
      this.shiftsData = res.results;
    });
  }
};
</script>
